// export const isSameUserType = ({ roleArray = [], role = '' }) => {
//   const smallRole = role?.toLowerCase();
//   const smallRoleArray = roleArray.map((e) => e.toLowerCase());
//   return smallRoleArray.includes(smallRole);
// };

export const isSameUserType = ({ roleArray = [], role = '' }) => {
  const smallRole = role?.toLowerCase();
  const smallRoleArray = roleArray.map((e) => e.toLowerCase());
  return smallRoleArray.some((type) => smallRole?.includes(type));
};

export const restrict2digitAfterDecimal = (stringOrValue = 0) => {
  const stringedValue = String(stringOrValue);
  return stringedValue?.includes('.') ? stringedValue.split('.')[0] + '.' + stringedValue.split('.')[1].slice(0, 2) : stringedValue;
};